import React, { useState } from 'react';
import { Select } from '../../../../atoms/Inputs/Select';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import { useSelector } from 'react-redux';
import { getChallengeStatus } from '../../../../../store/selectors/user/user.selectors';

export interface ProductListActionsProps {
  onAddToCart: () => void;
  setProductQuantity: (n: number) => void;
}
const ProductListActions = ({
  setProductQuantity,
  onAddToCart
}: ProductListActionsProps) => {
  const [value, setValue] = useState(1);
  const { status } = useSelector(getChallengeStatus);
  const handleClick = () => {
    onAddToCart();
    setValue(1);
  };
  const handleChange = (n: number) => {
    setProductQuantity(n);
    setValue(n);
  };
  return (
    <>
      <Select value={value} onChange={handleChange} maxValue={99} />
      <ButtonWithText
        content={'Ajouter au panier'}
        onClick={handleClick}
        disabled={status !== 'available'}
      />
    </>
  );
};

export default ProductListActions;
